import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 清空 ")
const _hoisted_3 = { style: {"float":"right","padding-right":"10px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 返回 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", null, "取消分享", -1)
const _hoisted_13 = {
  key: 1,
  style: {"color":"#c1c1c1","cursor":"not-allowed"}
}
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]

import { onMounted, ref, toRaw } from 'vue'
import SearchBar from '@/components/common/SearchBar.vue'
import { debounce } from '@/utils/common'
import { getShareList, cancelShare, getTeacherShareCourseware } from '../service'
import {
  CoursewareTypeOpts,
  CoursewareTypeMap,
  ShareStatusMap,
  PublishTypeMap,
  CoursewareType,
  ShareStatusTypeMap
} from '../config.js'
import {
  getSubjectEnum,
  getPressVersionEnum
} from '@/services/teaching-material'
import SelectBookModal from '@/views/songs/components/SelectBookModal.vue'
import { message } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import { usePageTableContext } from '@evideo/frontend-utils'
import pageTableContextMap from '@/utils/pageTableContextMap'
import PlanPreview from '@/views/courseware-square/components/PlanPreview.vue'

// 路由

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

// 搜索输入框
const queryParams = ref<any>()

// 表单
const formParams = ref<any>({
  type: undefined,
  subject_cat_id: undefined,
  press_version_cat_id: undefined,
  official_book_id: undefined,
  official_book_section_id: undefined
})

// 列表数据
const tableData = ref<any[]>()

// 分页信息
const pagination = ref({
  current: 1,
  total: 1,
  pageSize: 10,
  showTotal: (total: number) => `共${total}条`,
  showQuickJumper: false
})

const loading = ref<boolean>(true)

// 学科信息
const subjectOpts = ref<any[]>([])

const planContent = ref('')

// 出版设信息
const pressVersionOpts = ref<any[]>([])

const selectBookVisible = ref<boolean>(false)

const showBookName = ref<string>('')

const BookTypeMap = {
  OFFICIAL: 1
}

const AreaPublishType = '2'

// 预览
const previewVisible = ref<boolean>(false)

const currentPreview = ref<{ type: string; url: string } | undefined>(
  undefined
)

const columns = [
  {
    title: '课件名称',
    dataIndex: 'name',
    width: 150,
    ellipsis: true
  },
  {
    title: '课件类型',
    dataIndex: 'type',
    width: 100,
    slots: { customRender: 'type' }
  },
  {
    title: '编号',
    dataIndex: 'id',
    width: 80,
    ellipsis: true
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    width: 100,
    slots: { customRender: 'status' }
  },
  {
    title: '学科',
    dataIndex: ['subject', 'name'],
    width: 100,
    ellipsis: true
  },
  {
    title: '出版社',
    dataIndex: ['press_version', 'name'],
    width: 120,
    ellipsis: true
  },
  {
    title: '所属教材',
    dataIndex: ['book', 'name'],
    width: 180,
    ellipsis: true
  },
  {
    title: '所属章节',
    dataIndex: 'section_breadcrumb',
    width: 180,
    ellipsis: true
  },
  {
    title: '公开范围',
    dataIndex: 'publish_type',
    width: 100,
    slots: { customRender: 'publish_type' }
  },
  {
    title: '分享时间',
    dataIndex: 'created_at',
    width: 180
  },
  {
    title: '审核时间',
    dataIndex: 'audited_at',
    width: 180,
    slots: { customRender: 'audited_at' },
    ellipsis: true
  },

  {
    title: '审核意见',
    dataIndex: 'audit_note',
    width: 150,
    ellipsis: true
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 150,
    slots: { customRender: 'action' }
  }
]

const { getContextInfo, saveContextInfo, deleteContextInfo } = usePageTableContext()

const handleSaveContext = () => {
  const pageContext = {
    formParams: toRaw(formParams.value),
    queryParams: toRaw(queryParams.value),
    currentPage: pagination.value.current,
    showBookName: showBookName.value
  }
  saveContextInfo(pageTableContextMap.MINE_COURSEWARE_SHARE_LIST, pageContext)
}

const handleGetContext = () => {
  const context = getContextInfo(pageTableContextMap.MINE_COURSEWARE_SHARE_LIST)
  const {
    currentPage,
    formParams: fparams,
    queryParams: qParams,
    showBookName: sbName
  } = context
  if (fparams) { formParams.value = fparams }
  if (qParams) { queryParams.value = qParams }
  if (sbName) { showBookName.value = sbName }
  if (currentPage && currentPage > 1) {
    pagination.value.current = currentPage
  }
  deleteContextInfo(pageTableContextMap.MINE_COURSEWARE_SHARE_LIST)
}

// 获取分享记录列表
const getShareRecord = debounce(async (params: any) => {
  console.log(params, toRaw(formParams.value))
  const qParams = {
    ...toRaw(formParams.value),
    name: queryParams.value,
    page: pagination.value.current,
    ...params
  }
  try {
    loading.value = true
    const { items, meta } = await getShareList(qParams)
    tableData.value = items
    pagination.value = {
      ...toRaw(pagination.value),
      ...meta,
      current: +meta.current_page
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    tableData.value = []
    loading.value = false
  }
})

// 当table发生变化时
const handleTableChange = (page: any) => {
  pagination.value = page
  getShareRecord({ page: page.current })
}

// 搜索
const handleSearch = () => {
  console.log('检索')
  pagination.value.current = 1
  getShareRecord({})
}

// 预览
const handlePreview = async (record: any) => {
  console.log(record)
  if (record.type === CoursewareType.PPT) {
    console.log('PPT preview')
    const pptId = record.courseware_id
    handleSaveContext()
    router.push(`/resource/mine-coursewares/share-list/${record.id}/${pptId}/preview`)
  } else if (record.type === CoursewareType.FLASH) {
    message.info('SWF课件类型暂不支持在线预览')
  } else {
    const data = await getTeacherShareCourseware(record.id)
    planContent.value = data
    currentPreview.value = { type: record.type, url: record.url }
    previewVisible.value = true
  }
}

// 获取学科信息
const handleGetSubjectOpts = async () => {
  try {
    const data = await getSubjectEnum()
    subjectOpts.value = data.map(item => ({
      label: item.name,
      value: item.id
    }))
  } catch (err) {
    console.log(err)
    subjectOpts.value = []
  }
}

// 获取出版社信息
const handleGetPressVersionOpts = async () => {
  try {
    const data = await getPressVersionEnum()
    pressVersionOpts.value = data.map(item => ({
      label: item.name,
      value: item.id
    }))
  } catch (err) {
    console.log(err)
    pressVersionOpts.value = []
  }
}

// 选择教材弹窗打开
const handleShowSelectModal = () => {
  selectBookVisible.value = true
}

// 选择教材
const handleSelectBookOk = (info: any) => {
  selectBookVisible.value = false
  const { values, labels } = info
  if (values && values.length > 0) {
    if (values[0]) {
      formParams.value.official_book_id = values[0]
    }
    if (values[1]) {
      formParams.value.official_book_section_id = values[1]
    }
  } else {
    formParams.value.official_book_id = undefined
    formParams.value.official_book_section_id = undefined
  }
  if (labels && labels.length > 0) {
    showBookName.value = labels.join('/')
  } else {
    showBookName.value = ''
  }
}

// 清空教材选择
const handleResetSelectBook = () => {
  selectBookVisible.value = false
  formParams.value.official_book_id = undefined
  formParams.value.official_book_section_id = undefined
  showBookName.value = ''
}

// 重置表单
const handleResetForm = () => {
  formParams.value = {
    type: undefined,
    subject_cat_id: undefined,
    press_version_cat_id: undefined,
    official_book_id: undefined,
    official_book_section_id: undefined
  }
  handleResetSelectBook()
  queryParams.value = undefined
  handleSearch()
}

// 取消预览
const handleCancelPreview = () => {
  previewVisible.value = false
  currentPreview.value = undefined
}

const handleGoBack = () => {
  router.push('/resource/mine-coursewares')
}

// 取消分享
const handleNoShare = async (record: any) => {
  console.log('取消分享')
  try {
    loading.value = true
    await cancelShare({ share_record_id: record.id })
    handleSearch()
    message.success('取消分享成功')
    loading.value = false
  } catch (err) {
    console.log(err)
    loading.value = false
  }
}

onMounted(() => {
  handleGetContext()
  getShareRecord({})
  handleGetSubjectOpts()
  handleGetPressVersionOpts()
})

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _directive_nopreventright = _resolveDirective("nopreventright")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "head_body" }, {
        default: _withCtx(() => [
          _createVNode(SearchBar, {
            value: queryParams.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (queryParams.value = $event)),
            onSearch: handleSearch
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { class: "content_body" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, { layout: "inline" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    style: {"width":"100%"},
                    gutter: [16, 16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "课件类型" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: _unref(CoursewareTypeOpts),
                                value: formParams.value.type,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (formParams.value.type = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "学科" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: subjectOpts.value,
                                value: formParams.value.subject_cat_id,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (formParams.value.subject_cat_id = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "出版社" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: pressVersionOpts.value,
                                value: formParams.value.press_version_cat_id,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (formParams.value.press_version_cat_id = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "所属教材章节" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: handleShowSelectModal
                              }, [
                                (showBookName.value.length > 15)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 0,
                                      title: showBookName.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(showBookName.value.slice(0, 15)) + "... ", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["title"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(showBookName.value || "请选择教材章节"), 1))
                              ]),
                              _withDirectives(_createVNode(_component_a_button, {
                                style: {"margin-left":"10px"},
                                size: "small",
                                onClick: handleResetSelectBook
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, showBookName.value.length > 0]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 16,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_a_button, {
                              style: {"margin-right":"15px"},
                              onClick: handleGoBack
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              style: {"margin-right":"15px"},
                              onClick: handleResetForm
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: handleSearch
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_table, {
                dataSource: tableData.value,
                columns: columns,
                rowKey: "id",
                pagination: pagination.value,
                loading: loading.value,
                onChange: handleTableChange,
                scroll: { x: 1300 }
              }, {
                type: _withCtx(({ text }) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(CoursewareTypeMap)[text] || text), 1)
                ]),
                status: _withCtx(({ text }) => [
                  _createVNode(_component_a_tag, {
                    color: _unref(ShareStatusMap)[text]?.color || ''
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(ShareStatusMap)[text].label), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                audited_at: _withCtx(({ text }) => [
                  (text && text.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(text), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                ]),
                publish_type: _withCtx(({ text }) => [
                  (text !== AreaPublishType)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(PublishTypeMap)[text]?.label || "未知"), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(PublishTypeMap)[text]?.label) + "-" + _toDisplayString("区域地址"), 1))
                ]),
                action: _withCtx(({ record }) => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        onClick: () => handlePreview(record)
                      }, "预览", 8, _hoisted_11),
                      _createVNode(_component_a_divider, { type: "vertical" }),
                      (record.status === _unref(ShareStatusTypeMap).WAIT)
                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                            key: 0,
                            title: "是否取消分享",
                            onConfirm: ($event: any) => (handleNoShare(record)),
                            placement: "left"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "取消分享"))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["dataSource", "pagination", "loading"])
            ]),
            _: 1
          }),
          _createVNode(SelectBookModal, {
            queryParams: {show_modules: 1},
            visible: selectBookVisible.value,
            "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (selectBookVisible.value = $event)),
            onOk: handleSelectBookOk,
            type: BookTypeMap.OFFICIAL
          }, null, 8, ["visible", "type"]),
          (previewVisible.value)
            ? (_openBlock(), _createBlock(_component_a_modal, {
                key: 0,
                visible: previewVisible.value,
                onCancel: handleCancelPreview,
                destroyOnClose: "",
                maskClosable: false,
                title: "预览课件",
                width: 1000,
                footer: null,
                style: {"text-align":"center","top":"20px"}
              }, {
                default: _withCtx(() => [
                  (currentPreview.value?.type === _unref(CoursewareType).IMAGE)
                    ? _withDirectives((_openBlock(), _createElementBlock("img", {
                        key: 0,
                        style: {"max-width":"100%","max-height":"80vh"},
                        src: currentPreview.value?.url
                      }, null, 8, _hoisted_14)), [
                        [_directive_nopreventright]
                      ])
                    : _createCommentVNode("", true),
                  (currentPreview.value?.type === _unref(CoursewareType).VIDEO)
                    ? _withDirectives((_openBlock(), _createElementBlock("video", {
                        key: 1,
                        style: {"width":"100%"},
                        controls: "",
                        src: currentPreview.value?.url,
                        controlslist: "nodownload"
                      }, null, 8, _hoisted_15)), [
                        [_directive_nopreventright]
                      ])
                    : _createCommentVNode("", true),
                  (currentPreview.value?.type === _unref(CoursewareType).AUDIO)
                    ? _withDirectives((_openBlock(), _createElementBlock("audio", {
                        key: 2,
                        style: {"width":"100%"},
                        controls: "",
                        src: currentPreview.value?.url,
                        controlslist: "nodownload"
                      }, null, 8, _hoisted_16)), [
                        [_directive_nopreventright]
                      ])
                    : _createCommentVNode("", true),
                  (currentPreview.value?.type === _unref(CoursewareType).SPEAK)
                    ? _withDirectives((_openBlock(), _createElementBlock("video", {
                        key: 3,
                        style: {"width":"100%"},
                        controls: "",
                        src: currentPreview.value?.url,
                        controlslist: "nodownload"
                      }, null, 8, _hoisted_17)), [
                        [_directive_nopreventright]
                      ])
                    : _createCommentVNode("", true),
                  (currentPreview.value?.type === _unref(CoursewareType).Plan)
                    ? _withDirectives((_openBlock(), _createBlock(PlanPreview, {
                        key: 4,
                        style: {"width":"100%"},
                        controls: "",
                        content: planContent.value
                      }, null, 8, ["content"])), [
                        [_directive_nopreventright]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["visible"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})